/*
 * @Desc: 文件描述
 * @Author: jiayi zhu
 * @Date: 2020-05-21 14:21:02
 * @LastEditors: lumingming
 */
export default {
  // 获取邀请活动信息
  getInviteActiveMes() {
    return this.http('Lottery', 'get', '/api/v1/share_activities/default');
  },
  getInviteList(data) {
    return this.http('Lottery', 'get', '/api/lite/user_invitations', data);
  },
  getCashMes() {
    return this.http('Lottery', 'get', '/api/lite/user_bonus_balances');
  },
  getWeChatQrcode(data) {
    return this.http('CRM', 'get', '/api/v1/share_activities/temp_qrcode', data);
  },
  getShareCouponList() {
    return this.http('Lottery', 'get', '/api/v1/user_coupon_activities');
  },
  getShareCouponDetail(id) {
    return this.http('Lottery', 'get', `/api/v1/user_coupon_activities/${id}`);
  },
  createCouponShare(data) {
    return this.http('Lottery', 'post', '/api/v1/user_coupon_activities', data);
  }
};
